import { Component, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MetricService } from '../../services/metric.service';
import { StateService } from '../../services/state.service';
import { GlobalConstants } from '../../../shared/global-constants';

export interface ScoreData {
  title: string;
  value: number;
  description: string;
}

@Component({
  selector: 'app-kpi-score',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kpi-score.component.html',
  styleUrl: './kpi-score.component.scss'
})
export class KpiScoreComponent {
  readonly metricId = input<string>();
  readonly title = input.required<string>();

  readonly institution = inject(StateService).institution;

  private metricService = inject(MetricService);
  readonly loading = signal<boolean>(true);
  readonly scoreData = signal<ScoreData | undefined>(undefined);

  constructor() {
    effect(() => {
      const institution = this.institution();
      const metricId = this.metricId();
      if (institution?.iid && metricId) {
        this.metricService.getMetricData(institution.iid, metricId)?.subscribe(data => {
          const scoreData = {
            title: this.title(),
            value: data.length > 1 ? data[data.length - 1][1] : 0,
            description: GlobalConstants.scoreDescription[data.length > 1 ? data[data.length - 1][1] : 0]
          }
          setTimeout(() => {
            this.scoreData.set(scoreData);
            this.loading.set(false);
          });
        });
      }
    });
  }
}
